"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configBaseUrl = void 0;
const axios_1 = __importDefault(require("axios"));
const axiosInstance = axios_1.default.create({
    headers: {
        'Content-Type': 'application/json'
    },
    // Default baseUrl is staging backend
    baseURL: 'https://ckaho.liqnft.com/api/'
});
exports.default = axiosInstance;
let interceptorEvents = [];
const configBaseUrl = (env) => {
    if (interceptorEvents.length) {
        interceptorEvents.forEach((id) => {
            axiosInstance.interceptors.request.eject(id);
        });
        interceptorEvents = [];
    }
    const interceptorEvent = axiosInstance.interceptors.request.use((config) => {
        if (env === 'mainnet-beta') {
            config.baseURL = 'https://candy-shop.liqnft.com/api/';
        }
        return config;
    }, (error) => {
        // Do something with request error
        return Promise.reject(error);
    });
    interceptorEvents.push(interceptorEvent);
};
exports.configBaseUrl = configBaseUrl;
